module.exports = __webpack_public_path__ + "img/xp_icon_sj03.png";